const BucketBrandType = Object.freeze({
  ami: { id: 'AMI', label: 'AMI' },
  other: { id: 'Other', label: 'Other' },
});

export default BucketBrandType;
